__webpack_require__.p = "https://assets-dev.bwbx.io/s3/lightsaber/_next/";